import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazy-load';
import { observer, PropTypes as mobxPropTypes } from 'mobx-react';
import Style from './ProductList-tw-styles';
import constants from './constants';
import Dropdown from './Dropdown';
import PLPStore from '../../../store/PLPStore';
import i18nMessages from '../../../constants/messages/pt-BR';
import dynamic from 'next/dynamic';

const ProductCards = dynamic(() => import('./ProductCard'));
const Typography = dynamic(() => import('../../Generic/Typography'));

const styles = Style.productList;

var lastScroll = 0;
var isVisibleTop;
var isIE;

class ProductList extends React.Component {
  constructor(props) {
    super(props);
    const { products_list } = this.props;
    this.state = {
      modified_products: products_list,
      sorting_dropdown_values: Object.keys(constants.sorting_dropdown_list),
      prevY: 0,
      prevYTop: 0,
      // NEW: when true, hide product list content from screen readers
      isDropdownOpen: false,
    };
    this.LazyLoading = this.LazyLoading.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    const { pageNumber } = this.props;
    const alp_body_parent = document.getElementsByClassName('breadcrumbContainer')[0]
      .parentNode;
    const articleBannerDiv = document.getElementsByClassName('product-list')[0];
    const scroll_adjust_div = document.createElement('div');
    scroll_adjust_div.className = 'scroll_adjust_div';
    scroll_adjust_div.id = 'scrolling_div';
    alp_body_parent.insertBefore(scroll_adjust_div, articleBannerDiv[0]);

    if (pageNumber != undefined) {
      const page = pageNumber;
      PLPStore.applyedFilterList[0].page = parseInt(page);
    }

    var objDiv = document.getElementById('scrolling_div');
    if (pageNumber > 1) {
      window.scrollTo(0, objDiv.offsetTop + 200);
    }

    try {
      var options = {
        root: null,
        rootMargin: '0px',
        threshold: 1.0,
      };
      this.observer = new IntersectionObserver(this.handleObserver.bind(this), options);
      this.observer.observe(this.loadingRef);
      this.observer1 = new IntersectionObserver(this.handleObserverTop.bind(this), options);
      this.observer1.observe(document.getElementById('scrolling_div'));
    } catch (error) {
      if (error) {
        isIE = true;
      } else isIE = true;
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  checkVisibleScroller = () => {
    var el = document.getElementById('scrolling_div');
    var top = el.offsetTop;
    var left = el.offsetLeft;
    var width = el.offsetWidth;
    var height = el.offsetHeight;
    while (el.offsetParent) {
      el = el.offsetParent;
      top += el.offsetTop;
      left += el.offsetLeft;
    }
    return (
      top < window.pageYOffset + window.innerHeight &&
      left < window.pageXOffset + window.innerWidth &&
      top + height > window.pageYOffset &&
      left + width > window.pageXOffset
    );
  };

  handleScroll = async () => {
    const { pageSlug } = this.props;
    let div_anchors = Array.from(document.getElementsByClassName('div_anchors'));

    var scroll_pos =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    if (Math.abs(scroll_pos - lastScroll) > window.innerHeight * 0.1) {
      lastScroll = scroll_pos;
      if (isVisibleTop) {
        isVisibleTop = false;
      } else {
        div_anchors.map(eachAnchor => {
          if (this.isVisibleElement(eachAnchor)) {
            if (
              parseInt(eachAnchor.getAttribute('pagenumber')) !== null &&
              parseInt(eachAnchor.getAttribute('pagenumber')) > 1
            ) {
              window.history.replaceState(
                '',
                document.title,
                pageSlug + '-page-' + eachAnchor.getAttribute('pagenumber')
              );
              PLPStore.applyedFilterList[0].page = parseInt(
                eachAnchor.getAttribute('pagenumber')
              );
            } else if (parseInt(eachAnchor.getAttribute('pagenumber')) === 1) {
              window.history.replaceState('', document.title, pageSlug);
              PLPStore.applyedFilterList[0].page = parseInt(
                eachAnchor.getAttribute('pagenumber')
              );
            }
          }
        });
      }
    }
  };

  checkVisible = () => {
    var scrollTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    var scrollHeight =
      (document.documentElement && document.documentElement.scrollHeight) ||
      document.body.scrollHeight;
    var clientHeight = document.documentElement.clientHeight || window.innerHeight;
    var scrolledToBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight;
    if (scrolledToBottom) {
      return true;
    } else {
      return false;
    }
  };

  isVisibleElement = element => {
    var scroll_pos = window.scrollY;
    var window_height = window.innerHeight;
    var el_top = element.offsetTop;
    var el_height = element.offsetHeight;
    var el_bottom = el_top + el_height;
    return (
      el_bottom - el_height * 0.55 > scroll_pos &&
      el_top < scroll_pos + 0.9 * window_height
    );
  };

  handleLoadMoreReverse = async () => {
    let scroll_div = document.getElementById('scrolling_div');
    const { PLPStore } = this.props;
    let updated_products_list = await PLPStore.handlePaginationReverse();
    if (updated_products_list != undefined) {
      this.setState({
        modified_products: updated_products_list,
      });
    }
    if (PLPStore.applyedFilterList[0].page > 1) {
      window.scrollTo(0, scroll_div.offsetTop + 600);
    }
  };

  handleLoadMore = async () => {
    const { PLPStore } = this.props;
    let updated_products_list = await PLPStore.handlePagination();
    if (updated_products_list != undefined) {
      this.setState({
        modified_products: updated_products_list,
      });
    }
  };

  onSortChange = async event => {
    const { PLPStore } = this.props;
    let sorted_products = await PLPStore.addSorting(event.target.value);
    this.setState({
      modified_products: sorted_products,
    });
  };

  onSortChange2 = async t => {
    const { PLPStore } = this.props;
    let sorted_products = await PLPStore.addSorting(t);
    this.setState({
      modified_products: sorted_products,
    });
  };

  handleObserverTop(entities) {
    const y = entities[0].boundingClientRect.y;
    let { prevYTop } = this.state;
    if (prevYTop < y) {
      isVisibleTop = true;
    }
    this.setState({ prevYTop: y });
  }

  handleObserver(entities) {
    const y = entities[0].boundingClientRect.y;
    let { prevY } = this.state;
    if (prevY > y) {
      this.handleLoadMore();
    }
    this.setState({ prevY: y });
  }

  LazyLoading(child) {
    const { pageSlug } = this.props;
    return (
      <>
        {pageSlug !== 'produtos' ? (
          <LazyLoad offset={-30}>
            <>{child}</>
          </LazyLoad>
        ) : (
          child
        )}
      </>
    );
  }

  render() {
    const sorting_dropdown_object = constants.sorting_dropdown_list;
    const {
      PLPStore: { product_list },
    } = this.props;

    let { modified_products, isDropdownOpen } = this.state;
    const { PLPStore } = this.props;

    const loadingCSS = {
      height: '50px',
      margin: '30px',
    };

    const { sorting_dropdown_values } = this.state;

    return (
      <div className={classNames(styles.mainWrapper)}>
        <div className={classNames(styles.filterContainer)}>
          <div className={classNames(styles.buttonWrapper)}>
            <div className={classNames(styles.buttonDiv)}>
              <Typography component="span" className={classNames(styles.filterText)}>
                <strong>{PLPStore.totalProdCount}</strong>
                <span className={classNames(styles.filterText)}>
                  {product_list.length > 1
                    ? i18nMessages.plp_product_plural
                    : i18nMessages.plp_product_singular}
                </span>
              </Typography>
            </div>

            <div className={classNames(styles.gridRightWrapper)}>
              <div className={classNames(styles.sortWrapper)}>
                <div className={classNames(styles.sortFilter)}>
                  <Dropdown
                    key={0}
                    onSortChange={this.onSortChange2}
                    value={PLPStore.applyedFilterList[0].sort}
                    dValues={sorting_dropdown_values}
                    dObj={sorting_dropdown_object}
                    // NEW: allow dropdown to toggle background visibility for SR
                    onDropdownToggle={(open) => this.setState({ isDropdownOpen: !!open })}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {this.LazyLoading(
          <div
            className={classNames(styles.listWrapper)}
            // NEW: hide product cards (ratings) from screen readers while dropdown is open
            aria-hidden={isDropdownOpen ? 'true' : undefined}
            // Optional but helpful: prevent interaction while SR-hidden
            inert={isDropdownOpen ? '' : undefined}
          >
            {PLPStore.applyedFilterList[0].filter.hair_type != null ||
            (PLPStore.previous_url_hash_filter !== undefined &&
              PLPStore.previous_url_hash_filter !== null &&
              PLPStore.previous_url_hash_filter !== PLPStore.current_url_filter_string)
              ? product_list.map(
                  (eachPage, i) =>
                    eachPage.products.length !== null && (
                      <div
                        key={`product-${i + 1}`}
                        className={classNames(styles.listWrappers)}
                        pageNumber={eachPage.pageNumber}
                        itemUrl={eachPage.itemUrl}
                      >
                        {eachPage.products.map((eachProduct, i2) => {
                          return (
                            <ProductCards
                              lazyLoad={false}
                              key={i2 + 1}
                              indexNo={i2}
                              productData={eachProduct}
                            />
                          );
                        })}
                      </div>
                    )
                )
              : modified_products.map(eachPage =>
                  eachPage.products.length ? (
                    <div
                      className={classNames(styles.listWrappers)}
                      pageNumber={eachPage.pageNumber}
                      itemUrl={eachPage.itemUrl}
                    >
                      {eachPage.products.map((eachProduct, i2) => {
                        return (
                          <ProductCards
                            lazyLoad={false}
                            key={i2 + 1}
                            indexNo={i2 + 1}
                            productData={eachProduct}
                          />
                        );
                      })}
                    </div>
                  ) : (
                    ''
                  )
                )}
          </div>
        )}

        {!isIE ? (
          <div ref={loadingRef => (this.loadingRef = loadingRef)} style={loadingCSS}>
            <span />
          </div>
        ) : (
          PLPStore.load_more_display_state && (
            <div className={Style.ieLoadMoreDiv}>
              <button
                type="button"
                className={Style.ieLoadMoreBtn}
                id="loadmore"
                onClick={this.handleLoadMore}
              >
                {i18nMessages.loadmore}
              </button>
            </div>
          )
        )}
      </div>
    );
  }
}

ProductList.propTypes = {
  PLPStore: mobxPropTypes.observableObject.isRequired,
  pageNumber: PropTypes.string.isRequired,
  products_list: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

export default observer(ProductList);
